import React from 'react';
import {Dimensions} from 'react-native';
import Svg, {G, Rect} from 'react-native-svg';
import {useTheme} from '../../../theme';

const DashedDivider = ({color, space = 3, dashWidth = 3}) => {
  // Themed DEFAULT only (legacy grey4 → borderMuted; identical in light).
  const {colors} = useTheme();
  const resolvedColor = color === undefined ? colors.borderMuted : color;
  const {width} = Dimensions.get('screen');
  const spacing = space + dashWidth;

  const dashes = new Array(Math.floor(width / spacing)).fill(null);
  return (
    <Svg height="1" width="100%">
      <G>
        {dashes.map((_, index) => (
          <Rect
            key={index}
            x="0"
            y="0"
            width={String(dashWidth)}
            height="1"
            fill={resolvedColor}
            translateX={spacing * index}
          />
        ))}
      </G>
    </Svg>
  );
};

export default DashedDivider;
